const defineGaEvents = <T extends Record<string, null>>(keys: T) =>
  Object.freeze(
    Object.fromEntries(
      Object.keys(keys).map((key) => [key, key.toLowerCase()]),
    ) as {
      [K in Extract<keyof T, string>]: Lowercase<K>;
    },
  );

export const GA_EVENTS = defineGaEvents({
  AUTH_SIGNIN_EMAIL_SUBMIT: null,
  AUTH_SIGNIN_EMAIL_SUCCESS: null,
  AUTH_SIGNIN_EMAIL_FAILURE: null,
  AUTH_SIGNIN_PASSKEY_SUBMIT: null,
  AUTH_SIGNIN_PASSKEY_SUCCESS: null,
  AUTH_SIGNIN_PASSKEY_FAILURE: null,
  AUTH_SIGNIN_PASSWORD_SUBMIT: null,
  AUTH_SIGNIN_PASSWORD_SUCCESS: null,
  AUTH_SIGNIN_PASSWORD_FAILURE: null,
  AUTH_SIGNIN_SOCIAL_CLICK: null,
  AUTH_FORGOT_PASSWORD_CLICK: null,
  AUTH_NAVIGATE_SIGNUP_CLICK: null,
  AUTH_SIGNUP_SOCIAL_CLICK: null,
  AUTH_SIGNUP_CREATE_ACCOUNT_CLICK: null,
  AUTH_NAVIGATE_SIGNIN_CLICK: null,
  AUTH_SIGNUP_DETAILS_SUBMIT: null,
  AUTH_SIGNUP_DETAILS_SUCCESS: null,
  AUTH_SIGNUP_DETAILS_FAILURE: null,
  AUTH_SIGNUP_PASSWORD_SUBMIT: null,
  AUTH_SIGNUP_PASSWORD_SUCCESS: null,
  AUTH_SIGNUP_PASSWORD_FAILURE: null,
  AUTH_RESET_PASSWORD_EMAIL_SUBMIT: null,
  AUTH_RESET_PASSWORD_EMAIL_SUCCESS: null,
  AUTH_RESET_PASSWORD_EMAIL_FAILURE: null,
  AUTH_RESET_PASSWORD_SUBMIT: null,
  AUTH_RESET_PASSWORD_SUCCESS: null,
  AUTH_RESET_PASSWORD_FAILURE: null,
  AUTH_RESET_PASSWORD_CONTINUE_CLICK: null,
  AUTH_RESET_PASSWORD_CONTINUE_SUCCESS: null,
  AUTH_RESET_PASSWORD_CONTINUE_FAILURE: null,
  AUTH_OTP_SUBMIT: null,
  AUTH_OTP_SUCCESS: null,
  AUTH_OTP_FAILURE: null,
  AUTH_OTP_RESEND_CLICK: null,
  AUTH_OTP_RESEND_SUCCESS: null,
  AUTH_OTP_RESEND_FAILURE: null,
  AUTH_INVITE_VALIDATION_START: null,
  AUTH_INVITE_VALIDATION_SUCCESS: null,
  AUTH_INVITE_VALIDATION_FAILURE: null,

  SEARCH_QUERY_SUBMITTED: null,
  SEARCH_SCOPE_CHANGED: null,
  SEARCH_SUGGESTION_CLICKED: null,
  SEARCH_RESULT_CLICKED: null,
  SEARCH_NO_RESULTS_VIEWED: null,

  ONBOARDING_ORG_SETUP_SUBMIT: null,
  ONBOARDING_ORG_SETUP_SUCCESS: null,
  ONBOARDING_ORG_SETUP_FAILURE: null,
  ONBOARDING_ORG_SETUP_RETRY_CLICK: null,
  ONBOARDING_ORG_SETUP_SELECT_PLAN_CLICK: null,
  ONBOARDING_ORG_SETUP_CONTACT_SUPPORT_CLICK: null,

  BILLING_PLANS_VIEWED: null,
  BILLING_CUSTOMER_SESSION_ATTEMPT: null,
  BILLING_CUSTOMER_SESSION_SUCCESS: null,
  BILLING_CUSTOMER_SESSION_FAILURE: null,
  BILLING_PRICING_SCRIPT_LOADED: null,
  BILLING_FLOW_CANCEL_CLICK: null,
  BILLING_PORTAL_ACTION_CLICK: null,
  BILLING_PORTAL_URL_ATTEMPT: null,
  BILLING_PORTAL_URL_SUCCESS: null,
  BILLING_PORTAL_URL_FAILURE: null,
  BILLING_PORTAL_OPENED: null,
  BILLING_CHECKOUT_FINALIZE_ATTEMPT: null,
  BILLING_CHECKOUT_FINALIZE_SUCCESS: null,
  BILLING_CHECKOUT_FINALIZE_FAILURE: null,
  BILLING_STATUS_VIEWED: null,

  ACCOUNT_SETTINGS_DELETE_PAGE_VIEWED: null,
  ACCOUNT_SETTINGS_DELETE_WIZARD_OPENED: null,
  ACCOUNT_SETTINGS_DELETE_WIZARD_CLOSED: null,
  ACCOUNT_SETTINGS_DELETE_REQUEST_SUBMIT: null,
  ACCOUNT_SETTINGS_DELETE_REQUEST_SUCCESS: null,
  ACCOUNT_SETTINGS_DELETE_REQUEST_FAILURE: null,
  ACCOUNT_SETTINGS_DELETE_RETURN_TO_SIGNIN_CLICK: null,
  ACCOUNT_SETTINGS_PASSKEY_ADD_SUBMIT: null,
  ACCOUNT_SETTINGS_PASSKEY_ADD_SUCCESS: null,
  ACCOUNT_SETTINGS_PASSKEY_ADD_FAILURE: null,
  ACCOUNT_SETTINGS_PASSKEY_RENAME_SUCCESS: null,
  ACCOUNT_SETTINGS_PASSKEY_RENAME_FAILURE: null,
  ACCOUNT_SETTINGS_PASSKEY_DELETE_SUCCESS: null,
  ACCOUNT_SETTINGS_PASSKEY_DELETE_FAILURE: null,

  API_MUTATION_SUCCESS: null,
  API_MUTATION_FAILURE: null,
});

export type GaEventName = (typeof GA_EVENTS)[keyof typeof GA_EVENTS];
